import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IonSearchbar, Platform, ModalController, AlertController, LoadingController } from '@ionic/angular/lazy';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';
import { CartService } from 'src/app/services/cart.service';
import { PersonService } from 'src/app/services/person.service';
import { PersonAddPage } from 'src/app/modals/person-add/person-add.page';
import { ObserverService } from 'src/app/services/observer.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-cart-customer',
    templateUrl: './cart-customer.page.html',
    styleUrls: ['./cart-customer.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CartCustomerPage implements OnInit {

    @ViewChild('query_search_bar_input', { static: false }) query_search_bar_input: IonSearchbar;

    spinner = null;
    person_search_params = null;
    online = false;
    all_people = [];
    visible_people = null;
    people = null;
    query = '';
    cart = null;
    modal_css_class = '';

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public loadingController: LoadingController,
        private personService: PersonService,
        private cartService: CartService,
        private observerService: ObserverService,
        private platform: Platform,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        this.platform.ready().then(async () => {
            let network_status = await Network.getStatus();
            this.online = network_status.connected;
        });

        this.personService.getPeople().then((people: any) => {
            if (people) { 
                this.all_people = people;
            }
        });

        this.cartService.get().then((cart) => {
            this.cart = cart;
        });

        this.observerService.subscribe('person_added|cart_customer_modal', (person) => {
            if (person) {
                this.all_people.push(person);
                let query = this.query.toLowerCase().trim();
                if (query.length) {
                    if (
                        (person.full_name && person.full_name.toLowerCase().includes(query)) ||
                        (person.number && person.number.toString().includes(query)) ||
                        (person.email_address && person.email_address.toLowerCase().includes(query)) ||
                        (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(query))
                    ) {
                        let people = this.visible_people;
                        people.push(person)
                        people.sort((a, b) => {
                            if (a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                            if (a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                            return 0;
                        });
                        this.visible_people = people;
                    }
                }
            }
        });

        this.observerService.subscribe('person_deleted|cart_customer_modal', (person) => {
            if (person) {
                for (let i = 0; i < this.all_people.length; i++) {
                    if (this.all_people[i].id === person["id"]) {
                        this.all_people.splice(i, 1);
                        break;
                    }
                }
                if (this.visible_people && this.visible_people.length) {
                    for (let i = 0; i < this.visible_people.length; i++) {
                        if (this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        });

        this.observerService.subscribe("person_updated|cart_customer_modal", (person) => {
            if (person) {
                for (let i = 0; i < this.all_people.length; i++) {
                    if (this.all_people[i].id === person.id) {
                        this.all_people[i] = person;
                        break;
                    }
                }
                if (this.visible_people && this.visible_people.length) {
                    for (let i = 0; i < this.visible_people.length; i++) {
                        if (this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            let query = this.query.toLowerCase().trim();
                            if (query.length) {
                                if (
                                    (person.full_name && person.full_name.toLowerCase().includes(query)) ||
                                    (person.number && person.number.toString().includes(query)) ||
                                    (person.email_address && person.email_address.toLowerCase().includes(query)) ||
                                    (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(query))
                                ) {
                                    let people = this.visible_people;
                                    people.push(person)
                                    people.sort((a, b) => {
                                        if (a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                                        if (a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                                        return 0;
                                    });
                                    this.visible_people = people;
                                }
                            }
                            break;
                        }
                    }
                }
            }
        });

        this.observerService.subscribe('network_status_changed|cart_customer_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("person_added|cart_customer_modal");
        this.observerService.destroy("person_deleted|cart_customer_modal");
		this.observerService.destroy("person_updated|cart_customer_modal");
        this.observerService.destroy("network_status_changed|cart_customer_modal");
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.query_search_bar_input) {
                this.query_search_bar_input.setFocus();
            }
        }, 200);
    }

    close() {
        this.modalController.dismiss();
    }

    async presentAddPersonModal() {
        const modal = await this.modalController.create({
            component: PersonAddPage,
            cssClass: this.modal_css_class,
            componentProps: {
                invoked_from: "cart_customer_modal"
            }
        });
        modal.onDidDismiss().then((data) => {
            if(data.data) {
                let person_id = data.data['person_id'];
                this.presentSpinner("Assigning customer").then(() => {
                    this.cartService.updatePerson(person_id).then(() => {
                        this.cartService.get().then((cart) => {
                            if(cart) {
                                if (cart['person'].organisation) {
                                    this.cartService.updateOrganisation(cart['person'].organisation.id).then(() => {
                                        this.spinner.dismiss();
                                        this.close()
                                    })
                                    .catch(() => {
                                        this.spinner.dismiss();
                                        this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
                                    });
                                } 
                                else{
                                    this.cartService.removeOrganisation().then(() => {
                                        this.spinner.dismiss();
                                        this.close()
                                    })
                                    .catch(() => {
                                        this.spinner.dismiss();
                                        this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
                                    });
                                }
                            }
                        })
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
                    });
                });


            }
        });
        return await modal.present();
    }



    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

    searchPeople() {
        let query = this.query.toLowerCase().trim();
        this.people = null;
        this.visible_people = null;
        if (query.length) {
            let people = [];
            for (let i = 0; i < this.all_people.length; i++) {
                if (
                    (this.all_people[i].full_name && this.all_people[i].full_name.toLowerCase().includes(query)) ||
                    (this.all_people[i].number && this.all_people[i].number.toString().includes(query)) ||
                    (this.all_people[i].email_address && this.all_people[i].email_address.toLowerCase().includes(query)) ||
                    (this.all_people[i].mobile_phone_number && this.all_people[i].mobile_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].work_phone_number && this.all_people[i].work_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].home_phone_number && this.all_people[i].home_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].organisation?.title && this.all_people[i].organisation?.title.toString().toLowerCase().includes(query))
                ) {
                    if(!this.all_people[i].full_name) {
                        this.all_people[i].full_name = '';
                    }
                    people.push(this.all_people[i]);
                }
            }
            people.sort((a, b) => {
                if (a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                if (a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                return 0;
            });
            this.people = people;
            this.showInitialVisiblePeople();
        }
    }

    showInitialVisiblePeople() {
        let promise = new Promise<void>((resolve, reject) => {
            this.visible_people = [];
            for (let i = 0; i < 20; i++) {
                if (this.people.length > i) {
                    this.visible_people.push(this.people[i]);
                } else {
                    break;
                }
            }
            resolve();
        });
        return promise;
    }

    showMoreVisiblePeople(event) {
        let count = this.visible_people.length;
        for (let i = 0; i < 20; i++) {
            let position = i + count;
            if (this.people.length > position) {
                this.visible_people.push(this.people[position]);
            } else {
                break;
            }
        }
        event.target.complete();
    }

    customerClicked(person) {
        this.cartService.updatePerson(person.id).then(() => {
            this.presentSpinner("Assigning customer").then(() => {
                if (person.organisation_id) {
                    this.cartService.updateOrganisation(person.organisation_id).then(async () => {
                        await this.spinner.dismiss();
                        await this.modalController.dismiss();
                    })
                    .catch(async () => {
                        this.spinner.dismiss();
                        this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
                    });
                } else {
                    this.cartService.removeOrganisation().then(async () => {
                        await this.spinner.dismiss();
                        await this.modalController.dismiss();
                    })
                    .catch(() => {
                        this.spinner.dismiss();
                        this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
                    });
                }
            });
        })
        .catch(() => {
            this.spinner.dismiss();
            this.presentAlert('Problem', 'Unfortunately there was a problem updating the customer');
        });
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}